import React, { useState, useRef } from "react";
import "./Vfx.css";

import editsVideo from "../assets/g.mp4";

import uno from "../assets/vfx/vfx.mp4";
import vdos from "../assets/vfx/vfxx.mp4";
import vtres from "../assets/vfx/vei.webm";
import vcuatro from "../assets/vfx/sn.webm";

import unoPoster from "../assets/vfx/vt.png";
import vdosPoster from "../assets/vfx/pu.png";
import vtresPoster from "../assets/vfx/pd.png";
import vcincoPoster from "../assets/vfx/pt.png";

const videos = [
  { video: vtres, title: "", poster: unoPoster },
  { video: vcuatro, title: "", poster: vdosPoster },
  { video: vdos, title: "", poster: vtresPoster },
  { video: uno, title: "", poster: vcincoPoster },
];

export default function Vfx() {
  const [selected, setSelected] = useState(0);
  const thumbnailsRef = useRef(null);

  const scroll = (direction) => {
    if (!thumbnailsRef.current) return;

    const container = thumbnailsRef.current;
    const firstChild = container.children[0];
    if (!firstChild) return;

    const scrollAmount = firstChild.clientWidth * 4;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="videos-section" id="edits">
      <div className="section-header">
        <video
          src={editsVideo}
          autoPlay
          muted
          loop
          playsInline
          webkitPlaysInline
          x5PlaysInline
          preload="auto"
          className="section-video"
        />
        <p>Proyectos audiovisuales y contenido creativo</p>
      </div>

      <div className="videos-container">
        {/* 🎬 Video principal */}
        <div className="main-video">
          <video
            src={videos[selected].video}
            controls
            autoPlay
            loop
            muted
            playsInline
            webkitPlaysInline
            x5PlaysInline
            preload="metadata"
          />
          <h3>{videos[selected].title}</h3>
        </div>

        {/* 🎞 Carrusel de miniaturas */}
        <div className="thumbnails-wrapper">
          <button className="scroll-btn left" onClick={() => scroll("left")}>
            ◀
          </button>

          <div className="thumbnails" ref={thumbnailsRef}>
            {videos.map((vid, index) => (
              <div
                key={index}
                className={`thumbnail ${selected === index ? "active" : ""}`}
                onClick={() => setSelected(index)}
              >
                {/* 👇 MINIATURA AHORA ES UNA IMG (iOS-friendly, no se rompe) */}
                <img
                  src={vid.poster}
                  alt="thumbnail"
                  className="thumbnail-img"
                />
                <span>{vid.title}</span>
              </div>
            ))}
          </div>

          <button className="scroll-btn right" onClick={() => scroll("right")}>
            ▶
          </button>
        </div>
      </div>
    </section>
  );
}
